import { stylesheet } from 'typestyle';
import { colors } from '../../assets/styles';

const styles = stylesheet({
  container: {
    background: colors.greyBackground,
    height: 6,
  },
  progressBar: {
    background: colors.primary,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    height: '100%',
    transitionProperty: 'width',
    transitionDuration: '.15s',
    transitionTimingFunction: 'linear',
  },
});

export default styles;
